import { render } from "./EditTemplate.vue?vue&type=template&id=12ceaa16&scoped=true"
import script from "./EditTemplate.vue?vue&type=script&lang=js"
export * from "./EditTemplate.vue?vue&type=script&lang=js"

import "./EditTemplate.vue?vue&type=style&index=0&id=12ceaa16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ceaa16"]])

export default __exports__